export const listChannel = [
    {
      name:'WhatsApp (V3)',
      value:'whatsapp',
      disabled: true,
    },
    {
      name:'Email (V2)',
      value:'email',
    },
    {
      name:'Call (V2)',
      value:'call',
    },
    {
      name:'SMS Reguler (V2)',
      value:'sms',
    },
    {
      name:'SMS OTP (V2)',
      value:'sms_otp',
    },
]
export const dataTokenChannel = [
    {
      name:'WhatsApp (V3)',
      value:'whatsapp',
      tokenDesc: 'Token',
      status: 'Not Generated',
      lastGenerated: '-'
    },
    {
      name:'Email (V2)',
      value:'email',
      tokenDesc: 'Token',
      status: 'Not Generated',
      lastGenerated: '-'
    },
    {
      name:'SMS OTP (V2)',
      value:'sms_otp',
      tokenDesc: 'Token',
      status: 'Not Generated',
      lastGenerated: '-'
    },
    {
      name:'SMS Reguler (V2)',
      value:'sms',
      tokenDesc: 'Token',
      status: 'Not Generated',
      lastGenerated: '-'
    },
    {
      name:'Call (V2)',
      value:'call',
      tokenDesc: 'Token',
      status: 'Not Generated',
      lastGenerated: '-'
    }
]